import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/ui/password-input";
import { portalLogin } from "@/modules/tramites/materialidad/clientPortalApi";
import PortalMaterialidadShell from "./PortalMaterialidadShell";

export default function PortalMaterialidadLoginPage() {
  const navigate = useNavigate();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await portalLogin(login.trim(), password);
      toast.success("Sesión iniciada.");
      if (data?.user?.must_change_password) {
        navigate("/portal-materialidad/cambiar-password", { replace: true });
      } else {
        navigate("/portal-materialidad/empresas", { replace: true });
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciales inválidas.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <PortalMaterialidadShell>
      <div className="space-y-6" data-testid="portal-materialidad-login">
        <div>
          <h1 className="text-2xl font-semibold text-[#0F2D5C]">Ingresar</h1>
          <p className="text-sm text-slate-600 mt-1">
            Use su código CLI-BNT o correo, y la contraseña que le entregó su despacho.
          </p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4 rounded-sm border border-slate-200 bg-white p-5 shadow-sm">
          <div>
            <Label htmlFor="portal-login">Código o correo</Label>
            <Input
              id="portal-login"
              className="rounded-sm"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              autoComplete="username"
              data-testid="portal-login-input"
            />
          </div>
          <div>
            <Label htmlFor="portal-password">Contraseña</Label>
            <PasswordInput
              id="portal-password"
              className="rounded-sm"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              data-testid="portal-password-input"
            />
          </div>
          <Button
            type="submit"
            className="rounded-sm w-full"
            disabled={busy || !login.trim() || !password}
            data-testid="portal-login-submit"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            Entrar
          </Button>
        </form>
        <p className="text-xs text-slate-500">
          ¿Tiene un enlace de solicitud? Ábralo directamente; no necesita iniciar sesión.
          {" "}
          <Link to="/portal-materialidad" className="text-[#0F2D5C] underline">
            Volver al inicio
          </Link>
        </p>
      </div>
    </PortalMaterialidadShell>
  );
}
